export default class AccessibilityHelper {
  idFor(element, objectId) {
    return element + objectId;
  }
}
